import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IFormKey, IFormSelectOption } from '../../models/forms';

@Component({
  selector: 'app-basic-form',
  templateUrl: './basic-form.component.html',
  styleUrls: ['./basic-form.component.scss']
})
export class BasicFormComponent {

  @Input() keys: IFormKey[] = [];
  @Input() form?: FormGroup;
  @Input() filteredList: Observable<IFormSelectOption[]>;
  @Input() keyupEnabled = false;
  @Input() hidePersonalData = false;
  
  @Output() selected = new EventEmitter();

  onKeyup() {
    if (this.keyupEnabled) {
      this.selected.emit();
    }
  }

  onInputChange(event: Event, item: any): void {
    if (item.uppercase) {
      const input = event.target as HTMLInputElement;
      const value = input.value.toUpperCase();
      const control = this.form.get(item.controlName);
      control?.setValue(value);
    } else if (item.isAmountField) {
      const input = event.target as HTMLInputElement;
      let rawValue = input.value;
      rawValue = rawValue.replace(/\./g, '');
      const control = this.form.get(item.controlName);
      control?.setValue(rawValue);
    }
  }

  onInputBlur(event: Event, item: any): void {
    if (!item.isAmountField) return;
    const input = event.target as HTMLInputElement;
    const control = this.form.get(item.controlName);
    let rawValue = control?.value;
    rawValue = rawValue?.replace(',', '.');
    const number = parseFloat(rawValue);
    if (!isNaN(number)) {
      const formatted = number.toLocaleString('it-IT', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      input.value = formatted;
    } else {
      input.value = '';
    }
  }
  

  setData(item: any) {
    this.selected.emit(item);
  }

  getErrorMessage(controlName: string): string {
    if (this.form.get(controlName)?.errors?.pattern) {
      return 'Valore non valido';
    } else if (this.form.get(controlName)?.errors?.maxAgeExceeded) { 
        return 'Documento scaduto - aggiornare il documento';
    }
    return 'Campo obbligatorio';
  }

}
